<template>
  <div class="container">
    <div v-if="current_step === 10" class="none-info">
      <img src="../../assets/images/desktop/exclamation.svg" alt="" />
      <div class="top">{{ main_data.list_more.title }}</div>
      <div class="button" @click="$emit('confirm-step', 11)">{{ main_data.list_more_yes.title }}</div>
      <div class="back" @click="$emit('confirm-step', 10)">{{ main_data.list_more_no.title }}</div>
    </div>
    <div v-else class="final-info">
      <img src="../../assets/images/desktop/exclamation.svg" alt="" />
      <div class="top">{{ main_data.list_final_top.title }}</div>
      <div class="middle">{{ main_data.list_final_middle.title }}</div>
      <div class="button" @click="$emit('confirm-step', 12)">{{ main_data.list_final.title }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  img {
    position: absolute;
    max-width: 11.5rem;
    max-height: 11.5rem;
    width: 11.5rem;
    height: 11.5rem;
    left: 50%;
    top: 0;
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }

  .none-info {
    width: 42rem;
    height: 34rem;
    border-radius: 5rem;
    background-color: $main_header_middle;
    font-size: 2.4rem;
    line-height: 1.24;
    text-align: center;
    color: $text-white;
    position: relative;
    padding: 0 4rem 0 4rem;

    .top {
      margin-top: 10rem;
    }

    .button {
      margin-top: 3.5rem;
      width: 100%;
      height: 7rem;
      border-radius: 3.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 2.8rem;
      line-height: 1.19;
      color: $text_white;
      background-color: $calc_button;
      cursor: pointer;
    }

    .back {
      margin-top: 2.1rem;
      line-height: 1.25rem;
      color: $calc_button;
      cursor: pointer;
    }
  }

  .final-info {
    width: 42rem;
    border-radius: 5rem;
    background-color: $main_header_middle;
    font-size: 2.2rem;
    line-height: 1.36;
    text-align: center;
    color: $text-white;
    position: relative;
    padding: 0 4.3rem 4.2rem 4.3rem;

    .top {
      margin-top: 10rem;
    }

    .middle {
      margin-top: 4rem;
    }

    .button {
      margin-top: 3.5rem;
      width: 100%;
      height: 7rem;
      border-radius: 3.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 2.4rem;
      line-height: 1.19;
      color: $text_white;
      background-color: $main_header_light;
      cursor: pointer;
    }
  }
}
</style>

<script>
export default {
  props: ["main_data", "current_step"],
};
</script>
